import { render, staticRenderFns } from "./BoxNowWidget.vue?vue&type=template&id=48cf6db4&"
import script from "./BoxNowWidget.vue?vue&type=script&lang=js&"
export * from "./BoxNowWidget.vue?vue&type=script&lang=js&"
import style0 from "./BoxNowWidget.vue?vue&type=style&index=0&id=48cf6db4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports